export default "__VITE_ASSET__CyhrmALC__"